/**
 * Full paths registered in `src/app/router.tsx` under `/app`.
 * Use with `navigate({ to, params })` from `useNavigate()`.
 */
export const trainingRoutes = {
  /** ບໍ່ມີຫນ້າສູນກາງ — ກັບຈາກພາກນີ້ໄປໜ້າຫຼັກພະນັກງານ */
  exitToAppHome: "/app/dashboard",
  sopList: "/app/training/sop",
  sopDetail: "/app/training/sop/$id",
  sopPdfPreview: "/app/training/sop/$id/pdf-preview",
  flowsList: "/app/training/flows",
  flowDetail: "/app/training/flows/$id",
  standardsList: "/app/training/standards",
  standardDetail: "/app/training/standards/$id",
  standardPdfPreview: "/app/training/standards/$id/pdf-preview",
  checklistsList: "/app/training/checklists",
  kpi: "/app/training/kpi",
} as const;

/** Shared layout for list rows using `<Button variant="ghost" />` + `navigate`. */
export const trainingListRowButtonClass =
  "h-auto min-h-0 w-full justify-start rounded-none border-b p-4 text-left font-normal last:border-b-0 hover:bg-muted/40";
